import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, BadgePercent, MessageCircle } from "lucide-react";
import offerArtwork from "../assets/images/Bildup_Ad.png";
import { trackEvent } from "../utils/analytics";
import "./SpecialOffer.css";

const WHATSAPP_URL =
  "https://wa.me/2348155196615?text=Hello%20BildUp%2C%20I%27d%20like%20to%20claim%20the%2010%25%20offer.";

const SpecialOffer = () => {
  return (
    <section
      id="special-offer"
      className="special-offer"
      aria-labelledby="special-offer-title"
    >
      <div className="special-offer__background" aria-hidden="true">
        <div className="special-offer__grid" />
        <div className="special-offer__glow special-offer__glow--one" />
        <div className="special-offer__glow special-offer__glow--two" />
        <div className="special-offer__orbit special-offer__orbit--large">
          <span />
        </div>
        <div className="special-offer__orbit special-offer__orbit--small">
          <span />
        </div>
        <div className="special-offer__ticker">
          LIKES&nbsp;&nbsp;•&nbsp;&nbsp;REACH&nbsp;&nbsp;•&nbsp;&nbsp;SALES&nbsp;&nbsp;•&nbsp;&nbsp;CREDIT ALERTS
        </div>
      </div>

      <div className="special-offer__container">
        <motion.div
          className="special-offer__art-column"
          initial={{ opacity: 0, x: -48, rotate: -2 }}
          whileInView={{ opacity: 1, x: 0, rotate: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          viewport={{ once: true, amount: 0.25 }}
        >
          <div className="special-offer__art-glow" aria-hidden="true" />
          <div className="special-offer__image-frame">
            <img
              src={offerArtwork}
              alt="BildUp brand-building campaign artwork"
              className="special-offer__image"
            />
            <div className="special-offer__image-shine" aria-hidden="true" />
          </div>

          <motion.div
            className="special-offer__discount-card"
            animate={{ y: [0, -9, 0] }}
            transition={{ duration: 3.4, repeat: Infinity, ease: "easeInOut" }}
          >
            <BadgePercent size={27} strokeWidth={2.2} aria-hidden="true" />
            <span>
              <strong>10% OFF</strong>
              Today only
            </span>
          </motion.div>
        </motion.div>

        <motion.div
          className="special-offer__content"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.75, delay: 0.12, ease: [0.22, 1, 0.36, 1] }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <h2 id="special-offer-title" className="special-offer__title">
            Enjoy <span>10% OFF</span> today as you turn those likes into sales!
          </h2>

          <p className="special-offer__copy">
            Likes are fine sha, but <strong>CREDIT ALERTS</strong> are the real goal!
          </p>

          <motion.a
            href={WHATSAPP_URL}
            onClick={() => trackEvent("whatsapp_click_special_offer")}
            target="_blank"
            rel="noopener noreferrer"
            className="special-offer__cta"
            aria-label="Send BildUp a WhatsApp message to claim 10 percent off"
            whileHover={{ scale: 1.035 }}
            whileTap={{ scale: 0.98 }}
          >
            <span className="special-offer__cta-icon">
              <MessageCircle size={23} fill="currentColor" aria-hidden="true" />
            </span>
            <span>Send a WhatsApp message</span>
            <ArrowUpRight size={21} aria-hidden="true" />
          </motion.a>

          <p className="special-offer__fine-print">Tap to chat directly with BildUp on WhatsApp.</p>
        </motion.div>
      </div>
    </section>
  );
};

export default SpecialOffer;
